import { inject } from '@angular/core';
import { SoundEffectsService } from '@marineform/fe-util';

export function manageSoundEffectsInitializer() {
  inject(SoundEffectsService).init();
}
